function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#323D43;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M244.6,485.9c3,3.1,7.1,4.8,11.4,4.8c4.3,0,8.4-1.7,11.4-4.8l204.7-207.4c53.1-53.8,53.1-141.4,0-195.3 c-25.8-26.2-60.1-40.6-96.7-40.6s-70.8,14.4-96.7,40.5l-22.7,23l-22.7-23c-25.8-26.2-60.1-40.6-96.7-40.6 c-36.5,0-70.9,14.4-96.7,40.6c-53.1,53.8-53.1,141.5,0,195.3L244.6,485.9z M62.7,105.7c19.8-20,46-31,73.9-31 c27.9,0,54.1,11,73.9,31l34.1,34.6c6,6.1,16.8,6.1,22.8,0l34.1-34.6c19.8-20,46-31,73.9-31c27.9,0,54.1,11,73.9,31 c40.9,41.5,40.9,108.9,0,150.4L256,451.9L62.7,256C21.8,214.6,21.8,147.1,62.7,105.7z"
});

var SvgPriljubljeno = function SvgPriljubljeno(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "regular",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPriljubljeno, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/priljubljeno.f7576e46.svg";
export { ForwardRef as ReactComponent };